import PropTypes from 'prop-types';
import { HighlightLabel } from 'components/UI/HighlightLabel/HighlightLabel';
import Image from 'components/UI/Image/Image';
import EventTileInfo from './EventTileInfo/EventTileInfo';
import { EventTileActions } from './EventTileActions/EventTileActions';
import { EventTileOverlay } from './EventTileOverlay';
import './EventTile.scss';

export const EventTile = (props) => {
  const {
    title,
    url,
    category,
    desktopImage,
    tabletImage,
    mobileImage,
    bookNowVisible,
    bookNowText = 'Book tickets',
    bookNowUrl,
    bookNowTarget,
    eventTime,
    venue,
    label,
    collapseOnMobile,
    tessituraId,
    performanceId,
    eventDateValue,
  } = props;

  const eventMetaData = {
    prodSeasonId: tessituraId,
    performanceId,
    performanceDate: eventDateValue,
  };

  const collapseClass = collapseOnMobile ? 'is-collapse' : '';
  const classes = ['event-tile', collapseClass].join(' ');

  return (
    <div className={classes} data-testid="event-tile">
      {label && <HighlightLabel>{label}</HighlightLabel>}

      {desktopImage && (
        <a href={url} className="event-tile__img">
          <EventTileOverlay />
          <Image
            alt={title}
            desktopImage={desktopImage}
            tabletImage={tabletImage}
            mobileImage={mobileImage}
          />
        </a>
      )}
      <div className="event-tile__info">
        <EventTileInfo
          url={url}
          title={title}
          genre={category}
          eventTime={eventTime}
          venue={venue}
          label={label}
          collapseOnMobile={collapseOnMobile}
        />

        <EventTileActions
          infoUrl={url}
          bookNowVisible={bookNowVisible}
          bookNowText={bookNowText}
          bookNowUrl={bookNowUrl}
          bookNowTarget={bookNowTarget}
          eventMetaData={eventMetaData}
        />
      </div>
    </div>
  );
};

EventTile.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  desktopImage: PropTypes.string.isRequired,
  tabletImage: PropTypes.string,
  mobileImage: PropTypes.string,
  bookNowVisible: PropTypes.bool,
  bookNowText: PropTypes.string,
  bookNowUrl: PropTypes.string,
  bookNowTarget: PropTypes.string,
  eventTime: PropTypes.string.isRequired,
  venue: PropTypes.string.isRequired,
  label: PropTypes.string,
  collapseOnMobile: PropTypes.bool,
  tessituraId: PropTypes.number,
  performanceId: PropTypes.number,
  eventDateValue: PropTypes.string,
};
